import angular from 'angular';
import uiBootstrap from 'angular-ui-bootstrap';
import './user-popup.css';
import userPopupService from './user-popup.service';
import services from '../../../../services';

const userPopup = angular.module('ttb.core.popups.userPopup', [
    userPopupService,
    uiBootstrap,
    services
])
    .name;

export default userPopup;



// WEBPACK FOOTER //
// ./components/popups/user-popup/index.js